import React from 'react'
import { omit, startCase } from 'lodash'
import { withStyles } from '@material-ui/core'
import classNames from 'classnames'
import formatStatNumber from 'utils/formatStatNumber'

export default withStyles(theme => ({
  stats: {
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    // width: 600,
    display: 'inline-block',
    [theme.breakpoints.down('sm')]: {
      // marginTop: 2,
      // marginRight: '-35px',
      width: '100%',
      whiteSpace: 'normal',
      // maxHeight: '66px',
      // overflowY: 'scroll',
    },
  },
  number: {
    marginRight: 3,
    fontSize: theme.typography.pxToRem(22),
  },
  stat: {
    backgroundColor: '#014c94',
    color: '#fff',
    display: 'inline-block',
    borderRadius: '10px',
    padding: '10px',
    textAlign: 'center',
    marginRight: 17,
    whiteSpace: 'nowrap',
    '&:last-child': {
      marginRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 5,
      '&:last-child': {
        marginRight: 0,
      },
      marginTop: 2,
      padding: 3,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 6,
      '&:last-child': {
        marginRight: 0,
      },
      padding: 4,
    },
  },
  total_sends: { backgroundColor: theme.palette.green },
  total_opens: { backgroundColor: theme.palette.orange },
  total_clicks: { backgroundColor: theme.palette.secondary.main },
  total_delivered: { backgroundColor: theme.palette.primary.main },
  unique_opens: { backgroundColor: theme.palette.pink },
  unique_clicks: { backgroundColor: theme.palette.purple },
  text: {
    fontSize: theme.typography.pxToRem(9),
    display: 'inline-block',
  },
}))(({ task, classes }) => {
  const stats = task.email_stats
    ? 'email_stats'
    : task.sms_stats
    ? 'sms_stats'
    : null

  return (
    <div className={classes.stats}>
      {stats
        ? Object.keys(omit(task[stats], 'vrevent_id')).map(stat => (
            <div
              className={classNames(classes.stat, classes[stat])}
              key={`task${task.id}stat${stat}`}
            >
              <span className={classes.number}>
                {formatStatNumber(task[stats][stat])}
              </span>
              <div className={classes.text}>
                {startCase(
                  task[stats][stat] === 1 && stat.slice(-1) === 's'
                    ? stat.slice(0, -1)
                    : stat,
                )
                  .split(' ')
                  .map(word => (
                    <div key={`task${task.id}stat${stat}word${word}`}>
                      {word}
                    </div>
                  ))}
              </div>
            </div>
          ))
        : null}
    </div>
  )
})
